/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type employee_absences_CreateRecurringAbsenceRequest = {
    /**
     * Type of absence: VACATION, SICK, PERSONAL, TRAINING, OTHER, ACCIDENT, COMP_TIME, or CHILD_SICK
     */
    absence_type: employee_absences_CreateRecurringAbsenceRequest.absence_type;
    /**
     * ID of the employee this absence is for
     */
    employee_id: string;
    /**
     * End date of the recurring series (YYYY-MM-DD), optional for open-ended
     */
    end_date?: string;
    /**
     * Start time for partial-day absences in HH:MM format
     */
    from_time?: string;
    /**
     * Whether this is a full-day absence
     */
    full_day?: boolean;
    /**
     * Optional notes about the absence
     */
    notes?: string;
    /**
     * Array of weekday numbers (1=Monday through 7=Sunday)
     */
    recurrence_days: Array<number>;
    /**
     * Interval between recurrences
     */
    recurrence_interval: number;
    /**
     * Recurrence type: WEEKLY, BI_WEEKLY, MONTHLY, or CUSTOM
     */
    recurrence_type: employee_absences_CreateRecurringAbsenceRequest.recurrence_type;
    /**
     * Start date of the recurring series (YYYY-MM-DD)
     */
    start_date: string;
    /**
     * Submit as request instead of direct approval
     */
    submit_as_request?: boolean;
    /**
     * End time for partial-day absences in HH:MM format
     */
    to_time?: string;
};
export namespace employee_absences_CreateRecurringAbsenceRequest {
    /**
     * Type of absence: VACATION, SICK, PERSONAL, TRAINING, OTHER, ACCIDENT, COMP_TIME, or CHILD_SICK
     */
    export enum absence_type {
        VACATION = 'VACATION',
        SICK = 'SICK',
        PERSONAL = 'PERSONAL',
        TRAINING = 'TRAINING',
        OTHER = 'OTHER',
        ACCIDENT = 'ACCIDENT',
        COMP_TIME = 'COMP_TIME',
        CHILD_SICK = 'CHILD_SICK',
    }
    /**
     * Recurrence type: WEEKLY, BI_WEEKLY, MONTHLY, or CUSTOM
     */
    export enum recurrence_type {
        WEEKLY = 'WEEKLY',
        BI_WEEKLY = 'BI_WEEKLY',
        MONTHLY = 'MONTHLY',
        CUSTOM = 'CUSTOM',
    }
}

